import { getDisplayCategories } from 'academy-common-lib/utils/categories';
import InfoButtonModalOpener from '../../../containers/AcademyToSoftware/InfoButtonModalOpener';
import { useLearningContentCardTo } from '../cardsHooks';
// @ts-expect-error Could not find a declaration file for module
import useFilterParams from '../../../hooks/useFilterParams';
import UsageTracker from '../../../utils/UsageTracker';
import enviro from 'enviro';
import LearningContentCardAwardLink from './LearningContentCardAwardLink';
import CardMenuIcon from '../../cardMenu/components/CardMenuIcon';
import ACContentCard from 'academy-common-lib/components/card/ACContentCard';
import ACThumbnailOverlay from 'academy-common-lib/components/card/ACThumbnailOverlay';
import { useCallback, useEffect, useState } from 'react';
import styled from 'styled-components';
import { ThumbnailTypeMap } from 'academy-common-lib/features/cards/constants';
import ACLearningContentTitle from 'academy-common-lib/features/cards/components/ACLearningContentTitle';
import { ACLearningContentTimeReadout } from 'academy-common-lib/features/cards/components/ACLearningContentTimeReadout';
import { useIsVariation } from '../../experiments/experimentsQueries';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Ribbon } from 'foundations-components/transitional/components/Ribbon';
import { View } from 'foundations-components/transitional/components/View';
import { EmbeddedVideo } from '../../video';
import { isQuizMeReleaseShortId } from '../../interactiveEducation/utils/quizMeUtils';
import { useHasGate } from '../../accounts';
import ACContentCardLarge from 'academy-common-lib/components/card/ACContentCardLarge';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const VIDEO_HOVER_TIMEOUT = 500;
const HeaderIcons = styled.div.withConfig({
  displayName: "StandardLearningContentCard__HeaderIcons",
  componentId: "gixt9c-0"
})(["position:absolute;top:14px;right:12px;z-index:2;"]);
const OnHoverVideoPlayer = ({
  item,
  isHovered,
  onCardClick
}) => {
  const videoOnHover = useIsVariation('acad-0032', 'variation');
  const [isVideoLoaded, setIsVideoLoaded] = useState(false);
  const [shouldStartLoading, setShouldStartLoading] = useState(false);
  useEffect(() => {
    let timeoutId;
    setIsVideoLoaded(false);
    if (isHovered) {
      timeoutId = setTimeout(() => {
        setShouldStartLoading(true);
      }, VIDEO_HOVER_TIMEOUT);
    } else {
      setShouldStartLoading(false);
    }
    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [isHovered]);
  if (!videoOnHover || item.type === 'LEARNING_PATH' || !isHovered || !shouldStartLoading) {
    return null;
  }
  const handleTimeUpdate = seconds => {
    sessionStorage.setItem(JSON.stringify({
      id: item.id,
      type: item.type,
      language: item.language
    }), String(seconds));
  };
  const handleVideoLoaded = () => {
    setIsVideoLoaded(true);
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(View, {
      blockSize: "100%",
      inlineSize: "100%",
      insetBlockStart: "0",
      insetInlineStart: "0",
      position: "absolute",
      visibility: isVideoLoaded ? 'visible' : 'hidden',
      children: /*#__PURE__*/_jsx(EmbeddedVideo, {
        autoPlay: true,
        fallbackThumbnailUrl: item.previewThumbnailRectangleUrl,
        language: String(item.language || 'en').toLowerCase(),
        lessonId: item.type === 'LESSON' ? item.id.toString() : undefined,
        mutedByDefault: true,
        onLoaded: handleVideoLoaded,
        onTimeUpdate: handleTimeUpdate,
        renderContext: "academy-play-on-hover",
        shortId: item.type === 'SHORT_FORM_CONTENT' ? item.id : undefined,
        startTime: Number(sessionStorage.getItem(JSON.stringify({
          id: item.id,
          type: item.type,
          language: item.language
        }))),
        trackId: item.type === 'TRACK' ? item.id : undefined
      })
    }), /*#__PURE__*/_jsx(View, {
      blockSize: "79%",
      insetBlockStart: "0",
      insetInlineEnd: "60px",
      insetInlineStart: "0",
      onClick: onCardClick,
      position: "absolute",
      visibility: isVideoLoaded ? 'visible' : 'hidden',
      zIndex: "50"
    })]
  });
};
const useHasInfoButton = ({
  id,
  type
}) => type === 'TRACK' && enviro.isQa() ? [11979, 35515440].includes(id) : [5, 12, 97, 2274639, 2202162].includes(id);
const InfoButton = ({
  displayCategories
}) => {
  if (!(displayCategories !== null && displayCategories !== void 0 && displayCategories.length)) return null;
  const label = displayCategories[0].toLowerCase();
  return /*#__PURE__*/_jsx(InfoButtonModalOpener, {
    selectedSoftware: label
  }, label);
};
export const StandardLearningContentCard = ({
  item,
  onItemClick,
  use,
  showOverview,
  footer,
  isGhost,
  position,
  overviewType,
  playlistId,
  thumbnailHeader,
  renderMenu = menu => menu,
  renderThumbnailContentTypeName = type => type,
  extraTrackingInfo,
  isFlushOnMobile = true,
  alwaysShowMenu,
  isNotFilterable,
  disableLink,
  title,
  thumbnailBody
}) => {
  var _lessonType$;
  const [isHovered, setIsHovered] = useState(false);
  const {
    id,
    type,
    language,
    name,
    progress,
    previewThumbnailRectangleUrl
  } = item;
  const {
    isDeprecated,
    certification,
    subCategories,
    duration
  } = item;
  const displayCategories = subCategories ? getDisplayCategories(subCategories) : [];
  const completed = (progress === null || progress === void 0 ? void 0 : progress.status) === 'COMPLETED';
  const {
    itemsCount = 0
  } = item;
  const {
    lessonType
  } = item;
  const {
    completedItemsCount = 0
  } = progress || {};
  const remainingItems = itemsCount - completedItemsCount;
  const displayInteractiveEducation = type === 'SHORT_FORM_CONTENT' && isQuizMeReleaseShortId(id);
  const hasInfoButton = useHasInfoButton(item);
  const to = useLearningContentCardTo({
    item,
    overviewType,
    playlistId,
    showOverview
  });
  const filterParams = useFilterParams();
  const handleOnClick = useCallback(() => {
    if (!disableLink) UsageTracker.track('interaction', Object.assign({
      action: 'content-card-click',
      contentId: id,
      contentType: type,
      appearsIn: overviewType,
      position,
      name,
      filters: JSON.stringify(filterParams),
      style: 'default',
      isInProgress: (progress === null || progress === void 0 ? void 0 : progress.status) === 'IN_PROGRESS',
      isCertification: certification,
      playlistId
    }, extraTrackingInfo));
    if (onItemClick) onItemClick(item);
  }, [disableLink, id, type, overviewType, position, name, filterParams, progress === null || progress === void 0 ? void 0 : progress.status, certification, playlistId, extraTrackingInfo, onItemClick, item]);
  const {
    hasGate: hasInboundCardDesign
  } = useHasGate('Academy:ContentCard:InboundDesign');
  if (hasInboundCardDesign) {
    return /*#__PURE__*/_jsx(ACContentCardLarge, {
      awardLink: /*#__PURE__*/_jsx(LearningContentCardAwardLink, {
        trackId: id,
        use: 'on-light'
      }),
      cardMenu: renderMenu( /*#__PURE__*/_jsx(CardMenuIcon, {
        item: {
          id,
          type: type,
          language: language
        },
        use: "on-dark"
      })),
      contentHref: to.pathname,
      contentType: certification ? 'CERTIFICATION' : ThumbnailTypeMap[type],
      "data-test-id": "learning-content-card",
      "data-test-is-certification": Boolean(certification),
      "data-test-is-unfilterable": Boolean(isNotFilterable),
      "data-test-meta": id,
      "data-test-type": type,
      imageSrc: previewThumbnailRectangleUrl,
      length: duration || itemsCount,
      lengthType: type === 'PLAYLIST' ? 'items' : 'time',
      linkMode: "react-router",
      name: name,
      onMouseEnter: () => setIsHovered(true),
      onMouseLeave: () => setIsHovered(false),
      progress: type === 'PLAYLIST' ? completedItemsCount : duration - ((progress === null || progress === void 0 ? void 0 : progress.remainingDuration) || 0),
      ribbonText: displayInteractiveEducation && /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.interactiveEducation.interactive"
      }),
      ribbonUse: 'beta',
      tags: displayCategories.map(categoryKey => /*#__PURE__*/_jsx(FormattedMessage, {
        message: `academyCommon.categories.${categoryKey}`
      }, categoryKey)),
      videoPlayer: /*#__PURE__*/_jsx(OnHoverVideoPlayer, {
        isHovered: isHovered,
        item: item,
        onCardClick: handleOnClick
      })
    });
  }
  return /*#__PURE__*/_jsx(ACContentCard, {
    "data-test-id": "learning-content-card",
    "data-test-is-certification": Boolean(certification),
    "data-test-is-unfilterable": Boolean(isNotFilterable),
    "data-test-meta": id,
    "data-test-type": type,
    disabled: isDeprecated || isGhost,
    isFlushOnMobile: isFlushOnMobile,
    name: name,
    onClick: handleOnClick,
    onMouseEnter: () => setIsHovered(true),
    onMouseLeave: () => setIsHovered(false),
    overflow: displayInteractiveEducation ? 'visible' : undefined,
    thumbnailOverlay: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs(ACThumbnailOverlay, {
        categories: displayCategories,
        completed: completed,
        contentType: certification ? 'CERTIFICATION' : ThumbnailTypeMap[type],
        contentTypeName: renderThumbnailContentTypeName( /*#__PURE__*/_jsx(ACLearningContentTitle, {
          certification: certification,
          lessonType: String((_lessonType$ = lessonType === null || lessonType === void 0 ? void 0 : lessonType[0]) !== null && _lessonType$ !== void 0 ? _lessonType$ : ''),
          type: type
        })),
        duration: duration || itemsCount,
        footer: footer || /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(ACLearningContentTimeReadout, {
            item: item
          }), type === 'TRACK' && /*#__PURE__*/_jsx(LearningContentCardAwardLink, {
            trackId: id,
            use: use
          })]
        }),
        remainingTime: (progress === null || progress === void 0 ? void 0 : progress.remainingDuration) || remainingItems,
        watermark: displayInteractiveEducation && /*#__PURE__*/_jsx(Ribbon, {
          use: "beta",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.interactiveEducation.interactive"
          })
        }),
        children: [thumbnailHeader, (alwaysShowMenu || !isDeprecated) && /*#__PURE__*/_jsx(HeaderIcons, {
          children: renderMenu( /*#__PURE__*/_jsx(CardMenuIcon, {
            item: {
              id,
              type: type,
              language: language
            },
            use: "on-dark"
          }))
        }), thumbnailBody]
      }), /*#__PURE__*/_jsx(OnHoverVideoPlayer, {
        isHovered: isHovered,
        item: item,
        onCardClick: handleOnClick
      })]
    }),
    thumbnailSrc: previewThumbnailRectangleUrl,
    title: title === undefined ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [name, hasInfoButton && /*#__PURE__*/_jsx(InfoButton, {
        displayCategories: displayCategories
      })]
    }) : null,
    to: disableLink || isDeprecated ? null : to,
    use: use
  });
};
export default StandardLearningContentCard;